(function () {
  'use strict';
  function init() {
    document.querySelectorAll('[data-lm-princess]').forEach(function (dialog) {
      if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialized = 'true';
      var key = dialog.dataset.storageKey;
      var designMode = window.Shopify && window.Shopify.designMode;
      var loginLink = dialog.querySelector('[data-princess-login-url]');
      var originalLoginHref = loginLink && loginLink.href;
      var lastFocus;
      var timer;
      var closeTimer;
      var openTimer;
      var isClosing = false;

      var sectionId = dialog.id.replace('lm-princess-', '');
      var triggerTab = document.getElementById('lm-princess-tab-' + sectionId) ||
                       document.querySelector('[data-princess-trigger][aria-controls="' + dialog.id + '"]') ||
                       document.querySelector('[data-princess-trigger]');

      function isDesktop() {
        return window.matchMedia('(min-width: 768px)').matches;
      }

      function prefersReducedMotion() {
        return Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      }

      function updateCollapseMetrics(cachedTabRect) {
        var dialogRect = dialog.getBoundingClientRect();
        if (!dialogRect.width || !dialogRect.height) return;
        var tabRect = cachedTabRect || (triggerTab && triggerTab.getBoundingClientRect());
        var hasTabRect = tabRect && tabRect.width > 0 && tabRect.height > 0;
        var targetX = hasTabRect ? (tabRect.left + tabRect.width / 2) : (window.innerWidth - 20);
        var targetY = hasTabRect ? (tabRect.top + tabRect.height / 2) : (window.innerHeight / 2);
        var dialogCenterX = dialogRect.left + dialogRect.width / 2;
        var dialogCenterY = dialogRect.top + dialogRect.height / 2;
        var dx = Math.round(targetX - dialogCenterX);
        var dy = Math.round(targetY - dialogCenterY);
        var sx = Math.max(0.025, Math.min(0.12, (hasTabRect ? tabRect.width : 38) / dialogRect.width));
        var sy = Math.max(0.08, Math.min(0.28, (hasTabRect ? tabRect.height : 108) / dialogRect.height));
        dialog.style.setProperty('--lm-collapse-x', dx + 'px');
        dialog.style.setProperty('--lm-collapse-y', dy + 'px');
        dialog.style.setProperty('--lm-collapse-scale-x', sx.toFixed(4));
        dialog.style.setProperty('--lm-collapse-scale-y', sy.toFixed(4));
      }

      function read(name) {
        try { var value = localStorage.getItem(key + ':' + name); if (value !== null) return value; } catch (_) {}
        try { return sessionStorage.getItem(key + ':' + name); } catch (_) { return null; }
      }
      function write(name, value) {
        try { localStorage.setItem(key + ':' + name, value); }
        catch (_) { try { sessionStorage.setItem(key + ':' + name, value); } catch (_) {} }
      }
      function hasShown() {
        return read('shown') === '1';
      }
      function markShown() {
        if (!designMode) write('shown', '1');
      }

      function close(instant) {
        if (!dialog.open || isClosing) return;
        window.clearTimeout(openTimer);
        dialog.classList.remove('is-opening-auto', 'is-opening-from-tab');

        if (!instant && isDesktop() && !prefersReducedMotion()) {
          isClosing = true;
          updateCollapseMetrics();
          dialog.classList.add('is-closing');
          document.documentElement.classList.add('lm-princess-closing');

          var finishClose = function () {
            if (!isClosing) return;
            isClosing = false;
            window.clearTimeout(closeTimer);
            dialog.removeEventListener('animationend', onAnimEnd);
            dialog.classList.remove('is-closing');
            if (dialog.open) dialog.close();
            window.setTimeout(function () {
              document.documentElement.classList.remove('lm-princess-closing');
            }, 90);
          };

          var onAnimEnd = function (event) {
            if (event.target === dialog) finishClose();
          };

          dialog.addEventListener('animationend', onAnimEnd);
          closeTimer = window.setTimeout(finishClose, 500);
          return;
        }

        dialog.close();
      }

      dialog.addEventListener('close', function () {
        isClosing = false;
        window.clearTimeout(closeTimer);
        window.clearTimeout(openTimer);
        dialog.classList.remove('is-closing', 'is-opening-auto', 'is-opening-from-tab');
        document.documentElement.classList.remove('lm-princess-open');
        if (lastFocus && lastFocus.isConnected) lastFocus.focus({ preventScroll: true });
      });
      dialog.addEventListener('cancel', function (event) { event.preventDefault(); close(); });
      dialog.addEventListener('click', function (event) {
        if (loginLink && event.target.closest('[data-princess-login-url]') === loginLink) {
          var email = dialog.querySelector('.lm-princess__email');
          email.value = email.value.trim();
          loginLink.href = originalLoginHref;
          if (!email.checkValidity()) {
            event.preventDefault();
            email.reportValidity();
            return;
          }
          if (email.value) {
            var loginUrl = new URL(loginLink.dataset.princessLoginUrl, window.location.origin);
            var originalUrl = new URL(originalLoginHref, window.location.origin);
            ['locale', 'region_country'].forEach(function (name) {
              if (originalUrl.searchParams.has(name)) loginUrl.searchParams.set(name, originalUrl.searchParams.get(name));
            });
            loginUrl.searchParams.set('return_to', loginLink.dataset.princessReturnTo);
            loginUrl.searchParams.set('login_hint', email.value);
            loginLink.href = loginUrl.toString();
          }
        }
        if (event.target.closest('[data-princess-close]')) close();
        if (event.target.closest('[data-princess-exit]')) close();
        if (event.target === dialog) {
          var rect = dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
        }
      });

      // Desktop trigger tab: click to open
      if (triggerTab) {
        triggerTab.addEventListener('click', function () {
          show(true); // manual trigger
        });
      }

      function show(isManual) {
        if (!dialog.isConnected || dialog.open || isClosing) return;
        if (!isManual && !designMode && hasShown()) return;
        var blocker = Array.from(document.querySelectorAll('dialog[open], [aria-modal="true"], .drawer.is-open, .drawer--visible, .drawer--is-open, .popup.is-visible')).some(function (node) {
          if (node.matches('.collection__filters__toggle')) return false;
          if (node.matches('.collection__filters__wrapper') && isDesktop()) return false;
          return node !== dialog && node.getClientRects().length > 0 && getComputedStyle(node).visibility !== 'hidden';
        });
        if (document.visibilityState === 'hidden' || blocker) {
          if (!isManual) timer = window.setTimeout(function () { show(false); }, 500);
          return;
        }
        var tabRectBeforeOpen = (isDesktop() && triggerTab) ? triggerTab.getBoundingClientRect() : null;
        lastFocus = document.activeElement;
        dialog.showModal();
        document.documentElement.classList.remove('lm-princess-closing');
        document.documentElement.classList.add('lm-princess-open');
        markShown();

        if (isDesktop() && !prefersReducedMotion()) {
          updateCollapseMetrics(tabRectBeforeOpen);
          dialog.classList.remove('is-opening-auto', 'is-opening-from-tab', 'is-closing');
          var openClass = isManual ? 'is-opening-from-tab' : 'is-opening-auto';
          dialog.classList.add(openClass);
          window.clearTimeout(openTimer);
          openTimer = window.setTimeout(function () {
            dialog.classList.remove('is-opening-auto', 'is-opening-from-tab');
          }, 480);
        }
      }

      function schedule() {
        window.clearTimeout(timer);
        // Both Desktop & Mobile: auto-popup once per browser, 5 seconds after first DOM ready
        if (hasShown()) return;
        var readyAt = Number(read('ready-at'));
        if (!Number.isFinite(readyAt) || readyAt <= 0) {
          readyAt = Date.now() + 5000;
          write('ready-at', String(readyAt));
        }
        timer = window.setTimeout(function () {
          show(false);
        }, Math.max(0, readyAt - Date.now()));
      }

      if (designMode) {
        document.addEventListener('shopify:section:select', function (event) { if (event.target.contains(dialog)) show(true); });
      } else {
        schedule();
        window.addEventListener('pageshow', function (event) { if (event.persisted) schedule(); });
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
}());
